/**
 * PR-36A — Reusable mobile-first WhatsApp share button.
 * Opt-in: callers wire it where they want a WA-first share affordance.
 * Does NOT replace any existing share UI.
 */
import { useState } from "react";
import {
  sharePrediction,
  shareVictory,
  shareChallenge,
  shareNation,
  type PredictionShareInput,
  type VictoryShareInput,
  type ChallengeShareInput,
  type NationShareInput,
} from "@/lib/whatsappViral/whatsappEngine";

type Props =
  | { kind: "prediction"; payload: PredictionShareInput; source?: string; label?: string; className?: string }
  | { kind: "victory"; payload: VictoryShareInput; source?: string; label?: string; className?: string }
  | { kind: "challenge"; payload: ChallengeShareInput; source?: string; label?: string; className?: string }
  | { kind: "nation"; payload: NationShareInput; source?: string; label?: string; className?: string };

export function WhatsAppShareButton(props: Props) {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (props.kind === "prediction") await sharePrediction(props.payload, { source: props.source });
      else if (props.kind === "victory") await shareVictory(props.payload, { source: props.source });
      else if (props.kind === "challenge") await shareChallenge(props.payload, { source: props.source });
      else await shareNation(props.payload, { source: props.source });
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      aria-label="Compartir por WhatsApp"
      className={
        props.className ??
        "inline-flex items-center gap-1.5 rounded-full bg-[#25D366] px-3 py-2 text-[12px] font-black text-white transition active:scale-95 disabled:opacity-60"
      }
    >
      <span aria-hidden>💬</span>
      <span>{props.label ?? "WhatsApp"}</span>
    </button>
  );
}